import { useGetStatement, useCurrentBillingPeriod } from '@app/sdk';
import { JsonViewer } from '@textea/json-viewer';
import { AccountContext } from '../../AccountContext';
import { useContext, useEffect, useState } from 'react';
import { ScrollableContentContainer } from '../../../tms/components/ScrollableContentContainer';
import { MessageHeader, MessageContent, Message, Icon, Button, Divider } from 'semantic-ui-react';
import BillingPeriodStatementView from './BillingPeriodStatementView';

export default function BillingPeriodStatements() {
  const { accountId, selectedBillingPeriod } = useContext(AccountContext);
  const [billingPeriodId, setBillingPeriodId] = useState<number>(1);
  const { data: currentBillingPeriod } = useCurrentBillingPeriod(accountId);
  const { data: statementData } = useGetStatement(
    accountId,
    billingPeriodId,
    currentBillingPeriod?.billingPeriodId || 1
  );
  const [jsonView, setJsonView] = useState(false);

  useEffect(() => {
    if (selectedBillingPeriod && selectedBillingPeriod.billingPeriodId !== currentBillingPeriod?.billingPeriodId) {
      setBillingPeriodId(selectedBillingPeriod.billingPeriodId);
    }
  }, [currentBillingPeriod?.billingPeriodId, selectedBillingPeriod]);

  return (
    <>
      <Divider inverted />
      {!currentBillingPeriod || currentBillingPeriod?.billingPeriodId === 1 ? (
        <div>
          <Message>
            <MessageHeader>
              <Icon name="info circle" />
              Statements
            </MessageHeader>
            <MessageContent>Complete period 1 to generate a statement</MessageContent>
          </Message>
        </div>
      ) : (
        <>
          <Button
            style={{ marginBottom: '5px' }}
            className="ui button"
            icon="eye alternate"
            labelPosition="left"
            content={
              <div>
                Switch view
                <div className="ui grey sub header"></div>
              </div>
            }
            onClick={() => setJsonView(!jsonView)}></Button>
          {jsonView ? (
            <ScrollableContentContainer height={'550px'}>
              <JsonViewer value={statementData} />
            </ScrollableContentContainer>
          ) : (
            <BillingPeriodStatementView {...statementData} />
          )}
          <Divider clearing />
          
        </>
      )}
    </>
  );
}
